const trackPricingDetails = (interaction) => {
  $.publish('room_page_interaction', {
    section: 'prices',
    element: 'pricing_details',
    interaction,
  });
};

/**
 * The pricing table renders one button per weekday and only the expanded day's is on screen, so the
 * visible event fires once for whichever appears first rather than once per button.
 */
const initPricingDetails = (sectionEl) => {
  const buttons = sectionEl.querySelectorAll('.js-pricing-details');
  if (buttons.length === 0) return;

  const readComment = id => document.getElementById(id)?.textContent?.trim() ?? '';

  const observer = new IntersectionObserver((entries) => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    trackPricingDetails('visible');
    observer.disconnect();
  }, { threshold: 0.2 });
  buttons.forEach(button => observer.observe(button));

  sectionEl.addEventListener('click', (event) => {
    if (!event.target.closest('.js-pricing-details')) return;

    trackPricingDetails('click');
    window.triggerShowPricingDetailsModal?.({
      pricingComment: readComment('pricingSection-comment-pricing'),
      packagesComment: readComment('pricingSection-comment-packages'),
    });
  });
};

export const init = () => {
  const $pricingSection = $.fn.findAnyInDocument('.c-pricing-table[data-type=pricing]');
  const $packagesSection = $.fn.findAnyInDocument('.c-pricing-table[data-type=packages]');

  if ($pricingSection.length === 1) {
    window.__PricingTableComponent = App.components.room_pricing_table(
      $pricingSection,
      'pricing',
      {
        onRowClick($el) {
          $.publish('room_page_interaction', {
            section: 'prices',
            element: 'weekday',
            element_value: $el.data('dayOfWeek'),
            interaction: 'click',
          });
        },
      },
    );

    initPricingDetails($pricingSection[0]);
  }

  if ($packagesSection.length === 1) {
    window.__PackagesTableComponent = App.components.room_pricing_table(
      $packagesSection,
      'packages',
      {
        onRowClick($el) {
          $.publish('room_page_interaction', {
            section: 'event_offers',
            element: 'event_offer',
            element_value: $el.find('.c-pricing-table__row--header .c-pricing-table__item--package').text().trim(),
            interaction: 'click',
          });
        },
      },
    );

    if (window.location.hash === '#eventOffersSection') {
      document.getElementById('eventOffersSection')?.scrollIntoView();
    }
  }
};
